import './political_affiliations';
import './political_affiliations-list';
import './political_affiliations-edit'; 